import { Link } from "react-router";

export function CourseFooter() {
  return (
    <footer className="border-t py-8">
      <div className="text-muted-foreground mx-auto flex w-[calc(100%-2rem)] max-w-7xl flex-wrap items-center justify-between gap-3 text-sm sm:w-[calc(100%-3rem)]">
        <Link className="text-foreground font-mono" to="/">
          makefile.fyi
        </Link>
        <div className="flex min-w-0 flex-wrap gap-x-4 gap-y-2 sm:justify-end">
          <Link className="underline-decoration underline" to="/course">
            Course
          </Link>
          <Link className="underline-decoration underline" to="/concepts">
            Concepts
          </Link>
          <Link className="underline-decoration underline" to="/commits">
            Repository
          </Link>
          <Link className="underline-decoration underline" to="/guide">
            How it works
          </Link>
          <Link className="underline-decoration underline" to="/pricing">
            Pricing
          </Link>
          <Link className="underline-decoration underline" to="/terms">
            Terms
          </Link>
          <Link className="underline-decoration underline" to="/privacy">
            Privacy
          </Link>
        </div>
      </div>
    </footer>
  );
}
